import { render } from "./Candidati.vue?vue&type=template&id=3c80a69b&scoped=true"
import script from "./Candidati.vue?vue&type=script&lang=js"
export * from "./Candidati.vue?vue&type=script&lang=js"

import "./Candidati.vue?vue&type=style&index=0&id=3c80a69b&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c80a69b"]])

export default __exports__